import { useEffect, useState } from 'react';

import { useMedia } from '@pp/core';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const useIsPortraitMax = (): boolean => {
  const isPortraitMax = useMedia(
    '(min-width: 375px) and (min-height: 658px) and (orientation: portrait) and (max-width: 1023px)'
  );

  return isPortraitMax;
};